export default __webpack_public_path__ + "static/bg-end-light-ac2fc48f492bb7dc5a19a21bf294a5f9.png";